/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import { useCreateUserEducation } from "../../../../../../api/mutations/user.mutation";

function EducationForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    level: yup.string().required("Please enter your education level"),
    programme: yup.string().required("Please enter your programme"),
    institute: yup.string().required("Please enter your institute/university"),
    result: yup.string().required("Please enter your results/GPA"),
    start_date: yup.date().required("Please enter the starting period"),
    end_date: yup.date().required("Please enter the ending period"),
  });

  const navigate = useNavigate();

  const userEducationMutation = useCreateUserEducation({
    onSuccess: (data) => {
      console.log("onSuccess");
      navigate("/u/user_profile#education");
    },
    onError: (error) => {
      if (error.message) {
      }
    },
    successMessage: "Education Added Successfully!",
  });

  const onCreate = (data) => {
    userEducationMutation.mutate({
      level: data.level,
      programme: data.programme,
      institute_string: data.institute,
      description: data.result,
      start_data: data.start_date,
      end_date: data.end_date,
    });
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onCreate}
      initialValues={{
        level: "",
        programme: "",
        institute: "",
        result: "",
        start_date: "",
        end_date: "",
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values,
        touched,
        errors,
      }) => (
        <Form noValidate onSubmit={handleSubmit} className="mt-5">
          <Row className="mb-2">
            <h3 className="mb-3">Add Education</h3>
            <Form.Group
              as={Col}
              controlId="validationFormikEduLvl"
              className="form-group text-start "
            >
              <Form.Label className="form-label fw-bold">
                Education Level
              </Form.Label>
              <Form.Control
                type="level"
                placeholder="Bachelor's"
                name="level"
                value={values.level}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              {errors.level}
            </Form.Control.Feedback>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikprogramme"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                My programme
              </Form.Label>
              <Form.Control
                type="programme"
                placeholder="Computer Science"
                name="programme"
                value={values.programme}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              {errors.programme}
            </Form.Control.Feedback>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikInstitute"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Institute/University
              </Form.Label>
              <Form.Control
                type="institute"
                placeholder="Computer Science"
                name="institute"
                value={values.institute}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              {errors.institute}
            </Form.Control.Feedback>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikResult"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Results/GPA
              </Form.Label>
              <Form.Control
                type="result"
                placeholder="4.00"
                name="result"
                value={values.result}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
            <Form.Control.Feedback type="invalid">
              {errors.result}
            </Form.Control.Feedback>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikWebsite"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Starting Period
              </Form.Label>
              <DatePicker
                selected={values.start_date}
                onChange={(date) => setFieldValue("start_date", date)}
                dateFormat="yyyy/MM/dd"
                className="form-control mb-0"
                placeholderText="Select start date"
              />
              {touched.start_date && errors.start_date && (
                <div className="text-danger">{errors.start_date}</div>
              )}
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikWebsite"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Ending Period
              </Form.Label>
              <DatePicker
                selected={values.end_date}
                onChange={(date) => setFieldValue("end_date", date)}
                dateFormat="yyyy/MM/dd"
                className="form-control mb-0"
                placeholderText="Select end date (optional)"
              />
              {touched.end_date && errors.end_date && (
                <div className="text-danger">{errors.end_date}</div>
              )}
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Add Education
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default EducationForm;
